/**
 * The optional "text me" box on the signup form (agreed 10-08). Unchecked by
 * default, never required.
 *
 * The server stores its own copy of the wording for SMS_CONSENT_VERSION
 * (OurplaceService/RegistrationService.cs, SmsConsent), never text from the
 * browser, so the two must match word for word: smsConsent.test.js checks it.
 * Changing the wording means a new version on both sides.
 */
export const SMS_CONSENT_VERSION = 'sms-2026-10-14-draft';

export const SMS_CONSENT_TEXT =
  'Yes, text me updates from Join Our Place. Msg & data rates may apply. '
  + 'Reply STOP to opt out, HELP for help. Consent is not a condition of signing up.';
